import { StripeProductTemplateFromJSON, StripeProductTemplateToJSON, } from './StripeProductTemplate';
/**
 * Check if a given object implements the UpdateStripeProductRequest interface.
 */
export function instanceOfUpdateStripeProductRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "template" in value;
    return isInstance;
}
export function UpdateStripeProductRequestFromJSON(json) {
    return UpdateStripeProductRequestFromJSONTyped(json, false);
}
export function UpdateStripeProductRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'template': StripeProductTemplateFromJSON(json['template']),
    };
}
export function UpdateStripeProductRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'template': StripeProductTemplateToJSON(value.template),
    };
}
